import type { AccommodationState } from '@/interfaces';
import { connect } from 'react-redux';
import { SearchFormPreview, type SearchFormPreviewProps } from '@/components/searchFormPreview/SearchFormPreview';

const mapStateToProps = (state: AccommodationState): SearchFormPreviewProps => ({
    checkInDate: state.filters.checkInDate,
    checkOutDate: state.filters.checkOutDate,
    rooms: state.filters.rooms,
});

export default connect(mapStateToProps)(SearchFormPreview);
